<template lang="pug">
.uk-modal(:id="`${modalName}-modal`")
    .uk-modal-dialog.uk-modal-dialog-large
        span.uk-modal-close.uk-close
        .uk-modal-header(v-if="hasHeader")
            h3(:id="`${modalName}-modal-header`" style="border: none;")
                slot(name="title")
        .uk-overflow-container(:id="`${modalName}-modal-content`")
            slot
        .uk-modal-footer(v-if="hasFooter")
            .footer-content
                slot(name="footer")
            .print-block
                //- span.print-all.uk-button(v-if="printContent.printAll" :id="`${modalNameShort}-modal-print-all`" :title="printAllTitle" @click="printContent.printAll")
                //-     i.uk-icon-print
                //-     |  Распечатать всё
                span.print-save.uk-button(:id="`${modalNameShort}-modal-print`" :title="printTitle" @click="print")
                    i(:class="printIcon")
                    |  Распечатать
                span.pdf-save.uk-button.uk-button-primary(:id="`${modalNameShort}-modal-save`" :title="saveTitle" @click="save")
                    i(:class="{[saveIcon]: !saveLoading, 'uk-icon-spinner': saveLoading, 'uk-icon-spin': saveLoading}")
                    |  Сохранить PDF
</template>

<script>
import { Base64, htmlStringToPrint } from '@/helpers'

export default {
    props: {
        modalName: String,
        modalNameShort: String,
        modalPrintContent: Object,
        onClose: Function,
        onShow: Function,
        hasHeader: {
            type: Boolean,
            default: false,
        },
        hasFooter: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            saveLoading: false,
            printContent: this.modalPrintContent,
            title: `Сертификаты и декларации | ${window.company.title}`,
            style: `
                #print-pdf-hint {
                    display: none;
                }
                #print-content {
                    font-size: 14px;
                    padding: 10px 20px 10px 20px;
                    border-radius: 10px;
                    background: #eeeeef;
                    font-family: Arial, Helvetica, sans-serif;
                }
                .header {
                    display: block;
                    font-size: 20px;
                    color: rgb(11, 13, 21);
                    font-weight: 600;
                    margin: 10px 0px 20px 5px;
                }
                #print-pdf-hint {
                    display: none;
                }
                .print-main-title {
                    text-align: center;
                    color: #4b6365;
                    border-bottom: 1px solid #4b6365;
                    font-weight: 600;
                }
                .reg_number {
                    color: #3498db;
                    margin-right: 15px;
                }
            `
        };
    },
    computed: {
        // printAllTitle() { return `Распечатать всё (не более 1500 ${!this.printContent.printAllTitle ? 'записей' : this.printContent.printAllTitle})` },
        printTitle() { return !this.printContent.printTitle ? "Печатная версия" : this.printContent.printTitle; },
        printIcon() { return !this.printContent.saveIcon ? "uk-icon-print" : this.printContent.saveIcon; },
        saveTitle() { return !this.printContent.saveTitle ? "Сохранить в PDF" : this.printContent.saveTitle; },
        saveIcon() { return !this.printContent.saveIcon ? "uk-icon-file-pdf-o" : this.printContent.saveIcon; },
    },
    methods: {
        print() { this.$store.dispatch('printHTML', {
            html: this.printContent.html,
            title: this.title,
            style: this.style

        }) },
        save() {
            this.saveLoading = true;

            this.$store.dispatch('downloadPDF', {
                html: this.printContent.html,
                title: this.title,
                style: this.style,
                filename: this.printContent.filename,
                target: 'tile'
            }).finally(() => this.saveLoading = false)
        },
        addCloseListener() {
            if (this.$props.onClose) {
                $(`#${this.modalName}-modal`).on({
                    'hide.uk.modal': this.$props.onClose
                });
            }
        },
        addOpenListener() {
            if (this.$props.onShow) {
                $(`#${this.modalName}-modal`).on({
                    'show.uk.modal': this.$props.onShow
                });
            }
        }
    },
    mounted() {
        this.addCloseListener()
        this.addOpenListener()
    }
}
</script>


<style lang="scss" scoped>
.uk-modal {
    .uk-modal-header {
        h3 { font-size: 24px; font-family: Arial,Tahoma,sans-serif !important; color: #444; margin: 0; padding: 0; }
        i { margin-right: 7px; }
    }
    .uk-modal-footer {
        display: flex;
        justify-content: space-between;
        padding: 20px 30px;
        height: 70px;
        .footer-content {
            display: flex;
        }
        .print-block {
            .uk-button {
                margin: 0 2px;
            }
        }
    }
}
</style>
